import trebuchetRegular from "../../assets/fonts/TREBUC.TTF";
import trebuchetBold from "../../assets/fonts/TREBUCBD.TTF";
import trebuchetBoldItalic from "../../assets/fonts/TREBUCBI.TTF";
import trebuchetItalic from "../../assets/fonts/TREBUCIT.TTF";
import { Font, StyleSheet } from "@react-pdf/renderer";

Font.register({
  family: "Trebuchet",
  fonts: [
    { src: trebuchetRegular },
    { src: trebuchetBold, fontWeight: "bold" },
    { src: trebuchetItalic, fontStyle: "italic" },
    { src: trebuchetBoldItalic, fontWeight: "bold", fontStyle: "italic" },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "Trebuchet",
    backgroundColor: "#F5F5F5",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  contentContainer: {
    flex: 1,
    overflow: "hidden",
    width: "100%",
    justifyContent: "flex-start",
    height: "100%",
    padding: 10,
  },
  table: {
    display: "table",
    marginHorizontal: "auto",
    marginBottom: 5,
    width: "100%",
    borderColor: "#d3d3d3",
  },
  header: {
    fontSize: 12,
    marginBottom: 5,
    marginTop: 3,
    textAlign: "center",
    color: "red",
  },
  title: {
    fontSize: 22,
    textAlign: "center",
    marginTop: 5,
    marginBottom: 5,
    width: "100%",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 0.2,
    borderColor: "#d3d3d3",
  },
  tableHeaderRow: {
    flexDirection: "row",
    borderBottomWidth: 0.2,
    borderColor: "#d3d3d3",
  },
  tableHeaderTipo: {
    alignItems: "center",
    color: "#ffffff",
    display: "flex",
    fontSize: 18,
    fontWeight: "bold",
    justifyContent: "center",
    marginBottom: 15,
    marginTop: 10,
    textAlign: "center",
    width: 350,
    paddingHorizontal: 10,
    borderRadius: 5,
    height: 48,
    overflow: "hidden",
  },
  tableHeader: {
    fontSize: 9,
    backgroundColor: "#000000",
    color: "#ffffff",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
  },
  tableCell: {
    textAlign: "center",
    paddingVertical: 5,
    paddingHorizontal: 2,
    borderWidth: 0.3,
    borderColor: "#d3d3d3",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tableCellQuote: {
    textAlign: "center",
    paddingVertical: 5,
    paddingHorizontal: 2,
    borderWidth: 0.3,
    borderColor: "#d3d3d3",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  tableCellQuoteRight: {
    textAlign: "right",
    paddingVertical: 5,
    paddingHorizontal: 5,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderColor: "#d3d3d3",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    height: "100%",
  },
  tableCellDataRight: {
    textAlign: "right",
    paddingVertical: 5,
    paddingHorizontal: 5,
    borderLeftWidth: 0.2,
    borderRightWidth: 0.2,
    borderColor: "#d3d3d3",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  tableCellStart: {
    textAlign: "left",
    paddingVertical: 5,
    paddingHorizontal: 5,
    borderWidth: 0.3,
    borderColor: "#d3d3d3",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  lastCell: {},
  tableData: {
    fontSize: 9,
    backgroundColor: "#f8f9fa",
  },
  tableDataTotales: {
    fontSize: 9,
    backgroundColor: "#666666",
    color: "white",
    fontWeight: "bold",
  },
  letrachica0: {
    fontSize: 11,
    width: "100%",
    margin: "auto",
    marginTop: 5,
    marginBottom: 5,
    textAlign: "center",
  },
  letrachica1: {
    fontSize: 10,
    width: "100%",
    margin: "auto",
    marginTop: 5,
    marginBottom: 5,
    textAlign: "center",
  },
  letrachica2: {
    fontSize: 10,
    width: "90%",
    margin: "auto",
    marginTop: 5,
    marginBottom: 10,
    textAlign: "center",
  },
  hr: {
    borderBottomColor: "#000",
    borderBottomWidth: 0.8,
    marginHorizontal: "auto",
    marginTop: 8,
    marginBottom: 12,
    width: "100%",
  },
  detallesSeccion: {
    marginHorizontal: "auto",
    marginTop: 0,
    width: "100%",
  },
  detallesSeccionNoIncluidos: {
    marginHorizontal: "auto",
    marginBottom: 5,
    width: "100%",
  },
  detallesTitulo: {
    fontSize: 11,
    fontWeight: "bold",
    backgroundColor: "#2c3e50",
    color: "#ffffff",
    padding: 6,
    marginBottom: 5,
  },
  detallesText: {
    fontSize: 11,
    marginBottom: 5,
    marginLeft: 10,
  },
  inventario: {
    marginHorizontal: "auto",
    marginTop: 5,
    marginBottom: 0,
    width: "100%",
  },
  inventariosubTitulo: {
    fontSize: 11,
    marginTop: 6,
    marginBottom: 5,
    marginLeft: 10,
    fontWeight: "bold",
  },
  inventarioNombres: {
    fontSize: 10,
    marginBottom: 5,
    marginLeft: 20,
    lineHeight: 1.1,
    width: "90%",
    textAlign: "left",
  },
  image: {
    marginTop: 5,
    marginBottom: 5,
    marginHorizontal: "auto",
    width: 80,
    height: "auto",
  },
  mail: {
    fontSize: 10,
    textAlign: "center",
    width: "100%",
  },
  footer: {
    marginTop: 0,
    marginBottom: 0,
    width: "100%",
    padding: 0,
  },

  // === TABLA INVENTARIO - ESTILO INDEPENDIENTE ===
  inventarioTable: {
    width: "100%",
    marginTop: 8,
    marginBottom: 10,
    border: "1 solid #000",
    fontSize: 10,
    fontFamily: "Trebuchet",
  },
  inventarioHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#2c3e50",
    color: "white",
    fontWeight: "bold",
  },
  inventarioHeaderCell: {
    padding: 6,
    textAlign: "center",
    borderRight: "1 solid #34495e",
    alignItems: "center",
    justifyContent: "center",
  },
  inventarioRow: {
    flexDirection: "row",
    borderBottom: "1 solid #ddd",
    backgroundColor: "#f8f9fa",
  },
  inventarioRowAlt: {
    flexDirection: "row",
    borderBottom: "1 solid #ddd",
    backgroundColor: "#ffffff",
  },
  inventarioCell: {
    padding: 5,
    textAlign: "center",
    borderRight: "1 solid #eee",
    alignItems: "center",
  },
  inventarioCellLeft: {
    padding: 5,
    textAlign: "left",
    paddingLeft: 8,
    borderRight: "1 solid #eee",
    alignItems: "center",
  },
  inventarioCellBold: {
    fontWeight: "bold",
  },
  inventarioFooterRow: {
    flexDirection: "row",
    backgroundColor: "#ecf0f1",
    fontWeight: "bold",
    borderTop: "2 solid #2c3e50",
  },
  parrafoNarrativo: {
    backgroundColor: "#ffffff",
    borderTopWidth: 0.5,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderLeftWidth: 3,
    borderColor: "#dddddd",
    borderRadius: 3,
    padding: 10,
    marginBottom: 8,
    marginTop: 4,
  },
  parrafoNarrativoText: {
    fontSize: 9,
    lineHeight: 1.5,
    textAlign: "center",
    fontWeight: "bold",
  },
  datosCampanaContainer: {
    backgroundColor: "#ffffff",
    borderWidth: 0.5,
    borderColor: "#dddddd",
    borderRadius: 3,
    marginBottom: 0,
    marginTop: 4,
    overflow: "hidden",
  },
  datosCampanaRow: {
    flexDirection: "row",
    alignItems: "stretch",
    borderBottomWidth: 0.5,
    borderBottomColor: "#eeeeee",
  },
  datosCampanaCell: {
    flex: 1,
    justifyContent: "flex-start",
    minHeight: 60,
    borderRightWidth: 0.5,
    borderRightColor: "#eeeeee",
  },
  datosCampanaCellLast: {
    borderRightWidth: 0,
  },
  datosCampanaHeader: {
    backgroundColor: "#2c3e50",
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 0,
  },
  datosCampanaLabel: {
    fontSize: 11,
    fontWeight: "bold",
    textTransform: "uppercase",
    color: "#ffffff",
  },
  datosCampanaValueWrap: {
    backgroundColor: "#ffffff",
    paddingVertical: 10,
    paddingHorizontal: 8,
  },
  datosCampanaValue: {
    fontSize: 10,
  },
});

export default styles;
